import { skipToken, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

const workflowListQuery = (enabled = true) =>
  getRanaApiV1().getQueryOptions({
    queryKey: ["workflows", "list"],
    queryFn: async () => getRanaApiV1().WorkflowsApi.workflowList({}),
    enabled,
  });

export const useWorkflowListQuery = (enabled?: boolean) => useQuery(workflowListQuery(enabled));

const workflowImageQuery = (workflowId: string | undefined) =>
  getRanaApiV1().getQueryOptions({
    queryKey: ["workflow", "image", workflowId],
    queryFn: workflowId
      ? () => getRanaApiV1().WorkflowsApi.workflowImageRetrieve({ workflowId })
      : skipToken,
  });

export const useWorkflowImageQuery = (workflowId: string | undefined) =>
  useQuery(workflowImageQuery(workflowId));
